import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '@app/components/public/LoginForm/LoginForm';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

const PublicLoginPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('common.login')}</PageTitle>
      <BaseRow gutter={[30, 30]}>
        <BaseCol xs={24} sm={24} xl={24}>
          <BaseCard id="step-form" padding="1.25rem">
            <LoginForm />
          </BaseCard>
        </BaseCol>
      </BaseRow>
    </>
  );
};

export default PublicLoginPage;
